import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, Fragment as _Fragment, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "flex flex-col items-center p-5 py-10 space-y-10" }
const _hoisted_2 = { class: "flex flex-col space-y-6 items-center" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "flex text-brand-light-gray" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "w-10 h-10 flex bg-brand-light-gray rounded-full" }, [
    /*#__PURE__*/_createElementVNode("svg", {
      class: "m-auto h-5 fill-current text-brand-black my-auto",
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 448 512"
    }, [
      /*#__PURE__*/_createElementVNode("path", { d: "M438.6 105.4c12.5 12.5 12.5 32.8 0 45.3l-256 256c-12.5 12.5-32.8 12.5-45.3 0l-128-128c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0L160 338.7 393.4 105.4c12.5-12.5 32.8-12.5 45.3 0z" })
    ])
  ])
], -1)
const _hoisted_4 = { class: "flex flex-col w-full items-center space-y-1 px-2" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "flex text-white text-2xl font-medium text-center" }, "Verification Required", -1)
const _hoisted_6 = { class: "flex flex-col space-y-3" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "text-brand-light-gray text- text-center" }, "To ensure the safety of all members of the Pineapple community you must verify that you are who you say you are, once submitted you will have view only access until your profile is verified by the Pineapple team. ", -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "text-white text-center" }, "Please upload a video 'selfie' with you saying the phrase \"Pineapple Lifestyle\"", -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", { class: "text-brand-light-gray text- text-center" }, [
  /*#__PURE__*/_createTextVNode("To ensure the safety of all members of the Pineapple community "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-white" }, "you must verify that you are a couple"),
  /*#__PURE__*/_createTextVNode(", once submitted you will have view only access until your profile is verified by the Pineapple team. ")
], -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", { class: "text-white text-center" }, [
  /*#__PURE__*/_createTextVNode("Please upload a video 'selfie' with one of you saying the phrase \"Pineapple Lifestyle\" "),
  /*#__PURE__*/_createElementVNode("span", { class: "font-semibold" }, "you both MUST be present in the video that is submitted or your verification will be rejected.")
], -1)
const _hoisted_11 = { class: "flex space-x-3" }
const _hoisted_12 = { class: "flex m-auto space-x-2.5" }
const _hoisted_13 = {
  key: 0,
  class: "my-auto pt-0.5"
}
const _hoisted_14 = /*#__PURE__*/_createElementVNode("circle", {
  class: "opacity-25",
  cx: "12",
  cy: "12",
  r: "10",
  stroke: "currentColor",
  "stroke-width": "4"
}, null, -1)
const _hoisted_15 = /*#__PURE__*/_createElementVNode("path", {
  class: "opacity-75",
  fill: "currentColor",
  d: "M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
}, null, -1)
const _hoisted_16 = [
  _hoisted_14,
  _hoisted_15
]
const _hoisted_17 = { class: "flex m-auto space-x-2.5" }
const _hoisted_18 = {
  key: 0,
  class: "my-auto pt-0.5"
}
const _hoisted_19 = {
  key: 1,
  class: "animate-spin text-brand-black m-auto h-5 w-5",
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}
const _hoisted_20 = /*#__PURE__*/_createElementVNode("circle", {
  class: "opacity-25",
  cx: "12",
  cy: "12",
  r: "10",
  stroke: "currentColor",
  "stroke-width": "4"
}, null, -1)
const _hoisted_21 = /*#__PURE__*/_createElementVNode("path", {
  class: "opacity-75",
  fill: "currentColor",
  d: "M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
}, null, -1)
const _hoisted_22 = [
  _hoisted_20,
  _hoisted_21
]
const _hoisted_23 = /*#__PURE__*/_createElementVNode("div", { class: "text-brand-light-gray text-center text-sm px-10" }, "Verification videos will be removed from our servers upon approval or rejection.", -1)

import {onMounted, ref} from 'vue';
import {Observable, ObservableEvent} from "@/services/observable/Observable";
import {CameraSource, MediaPicker} from "axiallon-capacitor-media-picker";
import {VideoEditor} from "@whiteguru/capacitor-plugin-video-editor";
import {Filesystem} from "@capacitor/filesystem";
import {Capacitor} from "@capacitor/core";
import {Ref} from "vue/dist/vue";
import ApiService from "@/services/api/apiService";
import {modalController, toastController} from "@ionic/vue";
import {UserBasicInformationInterface} from "@/interfaces/UserBasicInformationInterface";
import {AccountType} from "@/definitions/AccountType";


export default /*#__PURE__*/_defineComponent({
  __name: 'VerificationSheet',
  setup(__props) {


const loading = ref(true)
const posting = ref(false)
const videoSrc = ref()
const uploadProgress = ref(0)
const postVideo: any = ref()
const videoBusy = ref(false)
const postPhotos: Ref<string[]> = ref([])

const authUser: Ref<UserBasicInformationInterface|undefined> = ref()

const resizeVideoSrc = async () => {

  // Transcode with progress
  const progressListener = await VideoEditor.addListener(
      'transcodeProgress',
      (info) => uploadProgress.value = info.progress * 100
  );

  const mediaFileResult = await VideoEditor.edit({
    path: videoSrc.value,
    transcode: {
      keepAspectRatio: true,
    },
  })

  await progressListener.remove();
  uploadProgress.value = 0

  const file = await fetch(Capacitor.convertFileSrc(mediaFileResult.file.path))
  postVideo.value = await file.blob()

}


const addVideo = async () => {
  if (videoBusy.value) return

  try {

    const video = await MediaPicker.getPhoto({
      mediaType: 'video',
      source: CameraSource.Photos,
    })

    if (video.media.length) {
      videoSrc.value = video.media[0].path

      if (!postPhotos.value.length) {
        const thumbnail = await VideoEditor.thumbnail({
          path: videoSrc.value,
          at: 1000 * 3
        })

        const thumbnailFile = await Filesystem.readFile({
          path: thumbnail.file.path
        })
        postPhotos.value = [`data:${thumbnail.file.type};base64,${thumbnailFile.data}`]
      }

      videoBusy.value = false

      // const file = await fetch(video.media[0].webPath)
      // postVideo.value = await file.blob()
    }

  } catch (e) {
    console.error('error', e);
  } finally {
    videoBusy.value = false
  }

}

const submitVideo = async () => {

  try {
    posting.value = true

    await resizeVideoSrc()

    await ApiService.User().attachVerificationVideo(
        postVideo.value,
        (progress: any) => {
          uploadProgress.value = parseInt(`${progress}`)
        }
    )

    Observable.emit(ObservableEvent.UserChanged)

    const toast = await toastController.create({
      message: 'Thank you for submitting your verification video. Our team aim to review all verification submissions within 48 hours of submission.',
      duration: 3000,
      position: 'top',
      color: 'primary'
    });
    await toast.present();

    await modalController.dismiss()

  } catch (e: any) {

    posting.value = false

    if (!e.error) {
      const toast = await toastController.create({
        message: 'Unable to process and upload video. Please try again or contact @ADMIN if the issue persists.',
        duration: 3000,
        position: 'bottom',
        color: 'danger'
      });
      await toast.present();
    }

    const toast = await toastController.create({
      message: e.data.message,
      duration: 3000,
      position: 'bottom',
      color: 'danger'
    });
    await toast.present();
  }

}


onMounted(async () => {
  authUser.value = await ApiService.User().authUser()
  console.log(authUser.value)
  loading.value = false
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _hoisted_5,
        _createElementVNode("div", _hoisted_6, [
          (authUser.value && authUser.value.account_type !== _unref(AccountType).Couple)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _hoisted_7,
                _hoisted_8
              ], 64))
            : _createCommentVNode("", true),
          (authUser.value && authUser.value.account_type === _unref(AccountType).Couple)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                _hoisted_9,
                _hoisted_10
              ], 64))
            : _createCommentVNode("", true)
        ])
      ]),
      _createElementVNode("div", _hoisted_11, [
        _createElementVNode("button", {
          onClick: addVideo,
          class: _normalizeClass([{
              'bg-brand-lime text-brand-black' : !videoSrc.value,
              'bg-brand-dark-gray text-white' : videoSrc.value
            }, "flex rounded-full px-6 h-12 font-medium text-lg"])
        }, [
          _createElementVNode("div", _hoisted_12, [
            (!videoBusy.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_13, _toDisplayString(videoSrc.value ? 'Change' : 'Upload'), 1))
              : _createCommentVNode("", true),
            (videoBusy.value)
              ? (_openBlock(), _createElementBlock("svg", {
                  key: 1,
                  class: _normalizeClass([{
                    'text-white': videoSrc.value,
                    'text-brand-black': !videoSrc.value,
                 }, "animate-spin m-auto h-5 w-5"]),
                  xmlns: "http://www.w3.org/2000/svg",
                  fill: "none",
                  viewBox: "0 0 24 24"
                }, _hoisted_16, 2))
              : _createCommentVNode("", true)
          ])
        ], 2),
        (videoSrc.value)
          ? (_openBlock(), _createElementBlock("button", {
              key: 0,
              onClick: submitVideo,
              class: "flex rounded-full px-6 h-12 font-medium text-lg bg-brand-lime text-brand-black"
            }, [
              _createElementVNode("div", _hoisted_17, [
                (!posting.value)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_18, " Submit "))
                  : _createCommentVNode("", true),
                (posting.value)
                  ? (_openBlock(), _createElementBlock("svg", _hoisted_19, _hoisted_22))
                  : _createCommentVNode("", true)
              ])
            ]))
          : _createCommentVNode("", true)
      ])
    ]),
    _hoisted_23
  ]))
}
}

})